/*
 *
 * SearchForm
 *
 */

import { strapiPost } from "@/services/user-admin/api";
import { UploadOutlined } from "@ant-design/icons";
import { Button, Checkbox, message, Pagination, Space, Upload } from "antd";
import { useEffect, useState } from "react";
import useRefState from "../../../utils/useRefState";
import "./CustomMediaImageSelectModal.css";

const CustomMediaImageSelectModal = ({
  value = "",
  uploadUrl,
  changeImageBtnText,
  optType,
  onChange,
  onCancel,
  onLoadingState,
  multiple,
  rawdata,
}: any) => {
  const [messageApi, contextHolder]: any = message.useMessage();
  const [upLoading, setUpLoading]: any = useState(false);
  const [resourceList, setResourceList]: any = useState([]);
  const [pagination, setPagination, refPagination]: any = useRefState({
    pageSizes: [10, 20, 50, 100, 500, 1000],
    pageNo: 1,
    pageSize: 10,
    total: 0,
  });
  const triggerChange = (changedValue: any) => {
    if (onChange) {
      onChange(changedValue);
    }
  };

  const handleBeforeUpload = async (file: any) => {
    if (onLoadingState) onLoadingState(true);
    setUpLoading(true);
    const fileType: any = file.name.substring(file.name.lastIndexOf(".") + 1);
    const fileTypes: any = ["jpg", "jpeg", "png", "webp", "svg"];
    // console.log(fileType, "fileType");
    if (!fileTypes.includes(fileType.toLowerCase())) {
      messageApi.error("You can only upload filetype:" + fileTypes.join(","));
      setTimeout(() => {
        if (onLoadingState) onLoadingState(false);
        setUpLoading(false);
      }, 2000);
      return false;
    }
    const isLt2M: any = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      messageApi.error("Image must smaller than 2MB!");
      setTimeout(() => {
        if (onLoadingState) onLoadingState(false);
        setUpLoading(false);
      }, 2000);
      return false;
    }
    // console.log(file, "file");
    const formData: any = new FormData();
    formData.append("file", file);
    try {
      const data: any = await strapiPost(
        uploadUrl || "/uploadFileToMediaResource",
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      if (data.length) {
        triggerChange(multiple ? data : data[0]);
        console.log(data[0], "data-uploadGameResource");
        let newPagination = Object.assign({}, pagination, {
          pageNo: 1,
        });
        setPagination(newPagination);
        // getImgList(newPagination);
      } else {
        messageApi.error(data.msg);
      }
    } catch (err) {}

    // multipart/form-data
    setTimeout(() => {
      if (onLoadingState) onLoadingState(false);
      setUpLoading(false);
    }, 2000);

    return false;
  };

  const getImgList = async (config: any) => {
    const { data, total }: any = await strapiPost("/getMediaImgResource", {
      page: config?.pageNo,
      pageSize: config?.pageSize,
    });
    setResourceList(data);
    setPagination(Object.assign({}, refPagination.current, { total: total }));
  };
  useEffect(() => {
    getImgList(pagination);
  }, []);

  const handleCheckboxChange = (index: any) => {
    // 创建一个 resourceList 的副本
    const newResourceList = [...resourceList];
    if (multiple) {
      // 切换选中状态
      newResourceList[index].checked = !newResourceList[index].checked;
    } else {
      newResourceList.forEach((item, indx) => {
        item.checked = index === indx;
      });
    }

    // 更新状态
    setResourceList(newResourceList);
  };
  const handleOk = () => {
    let resData: any = [];
    resourceList.forEach((item: any, indx: any) => {
      if (item.checked) resData.push(item);
    });
    triggerChange(multiple ? resData : resData[0]);
  };

  // return <Input value={value} onChange={(e) => triggerChange(e.target.value)} />;
  return (
    <div className="custom-media-image-select-modal">
      {contextHolder}
      <Upload
        beforeUpload={(event) => handleBeforeUpload(event)}
        showUploadList={false}
      >
        <Button
          style={{ backgroundColor: "#67C23A", color: "white" }}
          loading={upLoading}
          disabled={upLoading}
          icon={<UploadOutlined />}
        >
          {upLoading ? "Up Loading" : changeImageBtnText || "Add New Images"}
        </Button>
      </Upload>
      <div className="media-image-list">
        {resourceList?.map((item: any, index: any) => (
          <div className="media-image-list-item" key={item?.id}>
            <div className="media-image-list-item-checkbox">
              <Checkbox
                checked={item.checked}
                onChange={(e) => handleCheckboxChange(index)}
              />
            </div>

            <div className="media-image-list-imgbox">
              <img src={item.url} />
            </div>
            <div className="media-image-info">
              <div className="media-image-info-title">{item.name}</div>
              <div className="media-image-info-size">
                {item.ext?.replace(".", "")} - {item.width}X{item.height}
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="media-image-pagination">
        <Pagination
          current={pagination?.pageNo}
          total={pagination?.total}
          pageSize={pagination?.pageSize}
          pageSizeOptions={pagination?.pageSizes}
          showSizeChanger
          showTotal={(total) => `Total ${total}`}
          onChange={(e) => {
            let newPagination = Object.assign({}, refPagination.current, {
              pageNo: e,
            });
            getImgList(newPagination);
            setPagination(newPagination);
          }}
          onShowSizeChange={(curr, size) => {
            let newPagination = Object.assign({}, pagination, {
              pageNo: 1,
              pageSize: size,
            });
            setPagination(newPagination);
          }}
        />
      </div>
      <Space size="small" className="dailog-footer">
        <Button disabled={upLoading} onClick={onCancel}>
          Cancel
        </Button>
        <Button
          loading={upLoading}
          disabled={upLoading}
          type="primary"
          htmlType="submit"
          onClick={handleOk}
        >
          Confirm
        </Button>
      </Space>
    </div>
  );
};

export default CustomMediaImageSelectModal;
